import { useEffect, useState } from "react";
import { isNewVersionAvailable, subscribe } from "../../services/appVersion";

// Global banner that appears when the API responds with a newer app version
// than the one this tab was booted against. The user chooses when to refresh;
// the banner stays out of the way of anything they are in the middle of doing.
function AppUpdateAvailableBanner() {
  const [updateAvailable, setUpdateAvailable] = useState(isNewVersionAvailable());
  const [isRefreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    return subscribe(() => setUpdateAvailable(true));
  }, []);

  if (!updateAvailable) return null;

  const handleRefresh = () => {
    if (isRefreshing) return;
    setIsRefreshing(true);
    window.location.reload();
  };

  return (
    <div
      role="status"
      aria-live="polite"
      className="alert alert-info d-flex align-items-center justify-content-between shadow-sm mb-0"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2000,
        borderRadius: 0,
        padding: "0.75rem 1rem",
      }}
    >
      <span className="me-3">
        A new version of Milipot is available. Refresh to get the latest updates.
      </span>
      <button
        type="button"
        className="btn btn-sm btn-primary"
        onClick={handleRefresh}
        disabled={isRefreshing}
        aria-busy={isRefreshing}
      >
        {isRefreshing ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
            Refreshing
          </>
        ) : (
          "Refresh"
        )}
      </button>
    </div>
  );
}

export default AppUpdateAvailableBanner;
